module.exports = __webpack_public_path__ + "static/rosewater-3a393cce43a12488c662b4a678727f16.png";